import { render, staticRenderFns } from "./BaseSmallSelect.vue?vue&type=template&id=6ff93f6b&scoped=true&"
import script from "./BaseSmallSelect.vue?vue&type=script&lang=js&"
export * from "./BaseSmallSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseSmallSelect.vue?vue&type=style&index=0&id=6ff93f6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff93f6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
